import { from } from "rxjs";

export class DistributionNumber {
    distributionNumberId: number;
    auctionClusterId: number;
    buyerId: number;
    buyerDisplayName: string;
    masterDataListRowId: number;
    distributionNumberRangeType: number;
    value: number;
    monday: number;
    tuesday: number;
    wednesday: number;
    thursday: number;
    friday: number;
    saturday: number;
    sunday: number;
    mondayEnabled: boolean;
    tuesdayEnabled: boolean;
    wednesdayEnabled: boolean;
    thursdayEnabled: boolean;
    fridayEnabled: boolean;
    saturdayEnabled: boolean;
    sundayEnabled: boolean;
    activeValue: number;
  }

  export class DistributionNumberSuggestion {
    from: number;
    till: number;
    value: number;
  }
